const MONEYBARN = 9;
const M247 = 57;
const OODLE = 58;
const MARSH = 13;
const MONEYWAY = 22;
const ADVANTAGE = 8;
const SMF = 53;
const STARTLINE = 39;
const LENDABLE = 68;
const CARFINANCE247 = 49;
const ALPHERA = 50;
const METROBANK = 69;
const BNP = 63;
const MANNISLAND = 62;
const MOTONOVO = 67;
const V12 = 66;
const BLUE = 48;
const BILLING = 29;
const RATESETTER = 44;
const CLOSE = 70;
const AUTOMONEY = 71;
const TANDEM = 72;
const ZOPA = 73;
const CREDITAGRICOLE = 74;
const NORTHRIDGEFINANCE = 75;
const CAMCO = 76;

module.exports = {
    MONEYBARN,
    M247,
    OODLE,
    MARSH,
    MONEYWAY,
    ADVANTAGE,
    SMF,
    STARTLINE,
    LENDABLE,
    CARFINANCE247,
    ALPHERA,
    METROBANK,
    BNP,
    MANNISLAND,
    MOTONOVO,
    V12,
    BLUE,
    BILLING,
    RATESETTER,
    CLOSE,
    AUTOMONEY,
    TANDEM,
    ZOPA,
    CREDITAGRICOLE,
    NORTHRIDGEFINANCE,
    CAMCO
};